import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";
import FontsService from "@/commons/services/Fonts";
import LoginUser from "./LoginUser";

/** store state model */
export interface FontsState {
  /** PDF用フォント(取得時にBase64変換済み) */
  pdfFont: string;
}

/**
 * ### Fonts store
 */
@Module({ name: "fonts" })
export default class Fonts extends VuexModule implements FontsState {
  pdfFont: string = "";

  @Mutation
  private GET_PDF_FONT(): string {
    return this.pdfFont;
  }

  @Mutation
  private SET_PDF_FONT(pdfFont: string): void {
    this.pdfFont = pdfFont;
    return;
  }

  @Action({ rawError: true })
  public async getPdfFont(payload: { userStore: LoginUser }): Promise<string> {
    const font: string = this.GET_PDF_FONT();

    if (!font) {
      const fontsService: FontsService = new FontsService();
      const font: Blob = await fontsService.getPdfFont(payload.userStore);
      const base64Font: string = await this.readAsDataURL(font);

      // localストレージに格納しきれないので、storeにフォントデータが持ちきれない
      // 現状は常にダウンロードさせる方針で進める
      //this.SET_PDF_FONT(base64Font);

      return base64Font;
    } else {
      return font;
    }
  }

  /**
   * readAsDataURL() wrapper
   *
   * @param file ファイル
   */
  @Action({ rawError: true })
  public async readAsDataURL(blob: Blob): Promise<string> {
    const fileReader: FileReader = new FileReader();

    return new Promise((resolve: any, reject: any) => {
      // 成功の場合は処理結果をresolve
      fileReader.onload = () => {
        const result: string = fileReader.result as string;
        resolve(result.split("base64,")[1]);
      };

      fileReader.readAsDataURL(blob);
      return;
    });
  }
}
